import styled from 'styled-components';

import { FONT_WEIGHTS } from 'shared/constants/theme';
import mediaQueries from 'shared/helpers/styled-components/mediaQueries';

type Variant = 'default' | 'modal' | 'selection' | 'text';

const getMarketingPriceIntegerStyle = (variant: Variant): string => {
  switch (variant) {
    case 'modal':
      return `
        font-size: var(--text-size-h2);
        line-height: var(--line-height-l);
        font-weight: ${FONT_WEIGHTS.demi};
      `;
    case 'text':
      return `
        font-size: inherit;
        line-height: inherit;
      `;
    default:
      return `
        font-size: var(--text-size-xxl);
        line-height: var(--line-height-xxl);
        font-weight: ${FONT_WEIGHTS.demi};
      `;
  }
};

const getMarketingPriceExponentStyle = (variant: Variant): string => {
  switch (variant) {
    case 'modal':
      return `
        font-size: var(--text-size-s);
        line-height: var(--line-height-m);
        font-weight: ${FONT_WEIGHTS.demi};
      `;
    case 'text':
      return `
        font-size: inherit;
        line-height: inherit;
      `;
    default:
      return `
        font-size: var(--text-size-h2);
        line-height: inherit;
        font-weight: ${FONT_WEIGHTS.demi};
      `;
  }
};

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-xs);

  p {
    margin: 0;
  }
`;

export const WrapperNetPrice = styled.p<{ variant: Variant }>`
  display: flex;
  align-items: flex-end;
  flex-wrap: wrap;
  gap: 4px;
  ${props => props.variant === 'modal' && 'gap: unset;'}
`;

export const PriceInformation = styled.p`
  font-size: var(--text-size-s);
  line-height: var(--line-height-m);
  color: var(--text-light);
`;

export const StrikeThroughPrice = styled.p`
  text-decoration: line-through;
  color: var(--text-default);
`;

export const MarketingPriceInteger = styled.span<{ variant: Variant }>`
  ${props => getMarketingPriceIntegerStyle(props.variant)}
`;

export const MarketingPriceExponent = styled.span<{ variant: Variant }>`
  ${props => getMarketingPriceExponentStyle(props.variant)}
`;

export const MarketingPriceTerms = styled.div`
  display: flex;
  margin-left: 2px;
  font-size: var(--text-size-s);
  line-height: var(--line-height-base);
  color: var(--text-light);
`;

export const RightColumn = styled.p<{
  variant: Variant;
}>`
  color: var(--text-light);
  text-align: ${({ variant }) => (variant === 'modal' ? 'right' : 'left')};
  word-break: break-all;

  ${mediaQueries.fromTablet<{ variant: Variant }>`
    text-align: ${({ variant }) => (variant !== 'default' ? 'right' : 'left')};
  `}
`;

export const AvailableCommitmentDurations = styled.p`
  font-size: var(--text-size-s);
  line-height: var(--line-height-base);
  font-weight: ${FONT_WEIGHTS.demi};

  ${mediaQueries.fromTablet`
      width: 90px;
      overflow-wrap: break-word;
  `}
`;

export const PriceWrapper = styled.div<{ isDisabled?: boolean }>`
  gap: var(--spacing-xs);
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;

  ${({ isDisabled }) =>
    isDisabled &&
    `
    text-decoration: line-through;
    color: var(--text-light);
  `};

  ${mediaQueries.fromTablet`
      align-items: flex-end;
      display: inline-flex;
      flex-direction: row;
      gap: var(--spacing-l);
      justify-content: space-between;
 `};
`;

export const DetailsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-xs);
`;

export const LeftColumn = styled.div<{
  variant: Variant;
}>`
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  flex-wrap: wrap;

  justify-content: ${({ variant }) =>
    variant === 'modal' ? 'flex-end' : 'flex-start'};
  text-align: ${({ variant }) => (variant === 'modal' ? 'right' : 'left')};

  ${mediaQueries.fromTablet<{ variant: Variant }>`
    justify-content: ${({ variant }) =>
      variant !== 'default' ? 'flex-end' : 'flex-start'};
    text-align: ${({ variant }) => (variant !== 'default' ? 'right' : 'left')};
  `}
`;
